<template>
  <div class="root">
    <!--结束弹窗-->
    <div class="popView" v-if="showEndView">
      <div class="grayView"></div>
      <div>
        <div class="popContent">
          <div class="popContentView">
            <div class="title">
              {{ currentBookName }}
            </div>

            <button class="closeBtn" title="默写下一章节" @click="showEndViewMethod(false, 1)">
              <svg viewBox="0 0 24 24" width="1.2em" height="1.2em" class="svgBox">
                <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M18 6L6 18M6 6l12 12">
                </path>
              </svg>
            </button>
            <div class="midContent">
              <div class="leftItem">
                <div class="progress-container" id="allAccuracy">
                  <svg class="progress-circle" width="100" height="100">
                    <circle cx="50" cy="50" r="40"></circle>
                    <circle class="progress-bar" cx="50" cy="50" r="40" :stroke-dasharray="circumference"
                      :stroke-dashoffset="accuracyOffset"></circle>
                  </svg>
                  <span class="percentValue">{{ accuracyPercent }}%</span>
                  <span class="percentName">正确率</span>
                </div>
                <div class="progress-container" id="allUseTime">
                  <svg class="progress-circle" width="100" height="100">
                    <circle cx="50" cy="50" r="40"></circle>
                    <circle class="progress-bar" cx="50" cy="50" r="40"></circle>
                  </svg>
                  <span class="percentValue">{{ formatTime(elapsedSeconds) }}</span>
                  <span class="percentName">章节耗时</span>
                </div>
                <div class="progress-container" id="allWPM">
                  <svg class="progress-circle" width="100" height="100">
                    <circle cx="50" cy="50" r="40"></circle>
                    <circle class="progress-bar" cx="50" cy="50" r="40"></circle>
                  </svg>
                  <span class="percentValue">{{ wpm }}</span>
                  <span class="percentName">WPM</span>
                </div>
              </div>
              <div class="midItem">
                <div class="wrongList">
                  <button v-for="(word, index) in wrongWords" :key="index" class="wrongWord" type="button"
                    :title="word.desc">
                    <span>{{ word.name }}</span>
                  </button>
                </div>
                <div class="noticeFooter">
                  <div class="noticeItem">
                    <svg viewBox="0 0 24 24" width="1.2em" height="1.2em" class="noticeSvg">
                      <path fill="currentColor"
                        d="m11.645 20.91l-.007-.003l-.022-.012a15.247 15.247 0 0 1-.383-.218a25.18 25.18 0 0 1-4.244-3.17C4.688 15.36 2.25 12.174 2.25 8.25C2.25 5.322 4.714 3 7.688 3A5.5 5.5 0 0 1 12 5.052A5.5 5.5 0 0 1 16.313 3c2.973 0 5.437 2.322 5.437 5.25c0 3.925-2.438 7.111-4.739 9.256a25.175 25.175 0 0 1-4.244 3.17a15.247 15.247 0 0 1-.383.219l-.022.012l-.007.004l-.003.001a.752.752 0 0 1-.704 0l-.003-.001Z">
                      </path>
                    </svg>
                    <span class="noticeValue">{{ noticeMessage }}</span>
                  </div>
                </div>
              </div>
              <div class="rightItem">
                <button class="btnSvg">
                  <svg viewBox="0 0 24 24" width="1.2em" height="1.2em">
                    <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                      stroke-width="2"
                      d="M8 9H7a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2h-1m-4 5V3M9 6l3-3l3 3">
                    </path>
                  </svg>
                </button>
              </div>
            </div>
            <div class="bottomContent">
              <button class="bottomBtn1" type="button" title="默写本章节" @click="showEndViewMethod(false)">重复本章节</button>
              <button id="nextBook" class="bottomBtn2" type="button" title="下一章节"
                @click="showEndViewMethod(false, 1)">下一章节</button>
              <button class="bottomBtn2" type="button" title="查看排行榜" @click="goToRanking">查看排行榜</button>
              <button class="bottomBtn2" type="button" title="编辑单词本" @click="goToEditBook">编辑单词本</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 主页 -->
    <div class="bodyView" :class="{ expanded: isGameViewExpanded }">
      <div class="mainView">
        <!-- 添加TopBar组件 -->
        <TopBar :user="user" :apps="apps" />
        <!-- 页首 -->
        <header class="container">
          <div class="containerDiv">
            <div class="containerTitle">{{ user.name }} {{ bookType === 'abhsChinese' ? '中文' : '英文' }}默写模式</div>
            <nav class="menu">
              <div v-if="hasPreviousBook" @click="goToPreviousBook" class="nav-arrow">
                <button class="side_btn">上一节</button>
              </div>

              <div class="relative">
                <div><a class="menuBtn" @click="goToGallery">{{ currentBookName }}</a></div>
              </div>

              <div v-if="hasNextBook" @click="goToNextBook" class="nav-arrow">
                <button class="side_btn">下一节</button>
              </div>

              <div class="relative">
                <div><a class="menuBtn" @click="goToRanking" style="color:green;">今日排名</a></div>
              </div>
              <div class="relative">
                <div><a class="menuBtn" @click="goToMainView" style="color:lightblue;">返回首页</a></div>
              </div>
              <div class="relative">
                <div><a id="gameBtn" class="menuBtn" style="color:rgb(75, 213, 142);" @click="toggleGameView">游戏模式</a>
                </div>
              </div>
            </nav>
          </div>
        </header>
        <!-- 页中 -->
        <div class="body">
          <div class="centerItem">
            <div class="center">
              <div class="center2">
                <div class="reminder" id="reminder" v-if="words && words.length > 0">
                  <img v-for="(word, index) in words" :key="index" :src="getStarImage(word, index)"
                    style="width: 10px; height: 10px;"
                    :style="{ border: index === currentWordIndex ? '3px solid lightblue' : 'none', borderRadius: index === currentWordIndex ? '50%' : 'none' }" />
                </div>
                <div class="remember">
                  <div class="starView" id="star" v-if="bookType === 'abhsWords'">
                    <img v-for="n in 3" :key="n" :src="getStarLevelImage(n)" style="width: 50px; height: 50px;" />
                  </div>
                  <div class="remember1" v-if="bookType === 'abhsWords'">
                    <div class="runStatus" id="runStatus" v-if="!isRunning">
                      <div class="remember111">
                        <p class="remmberP">按任意键 开始</p>
                      </div>
                    </div>
                    <div class="relative">
                      <div class="remember21">
                        <div class="remember211" data-tip="按 Tab 快捷键显示完整单词">
                          <div class="word" id="word" v-if="currentWordLetters && currentWordLetters.length > 0">
                            <span v-for="(letter, index) in currentWordLetters" :key="index" :ref="`letter-${index}`"
                              :class="getLetterClasses(index, letter.class)" :data-value="letter.value">
                              {{ letter.display }}
                            </span>
                          </div>

                          <div class="remember2112">
                            <div class="relative">
                              <div>
                                <button class="remember21121"></button>
                              </div>
                              <div class="remember21122">
                                <span class="tooltip">快捷键Ctrl + J</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- 中文 -->
                      <div class="desc" id="desc">
                        <span class="remember23P">{{ currentWordDesc }}</span>
                      </div>
                    </div>
                  </div>
                  <div v-else-if="bookType === 'abhsChinese'">
                    <mdui-button icon="queue_music" id="playBtn" @click="speakText"
                      :disabled="isSpeaking">一键播报</mdui-button>
                    <mdui-button icon="stop_circle" id="stopBtn" @click="stopSpeaking"
                      :disabled="!isSpeaking">暂停播报</mdui-button>
                    <mdui-button icon="checklist_rtl" id="checkBtn" :disabled="!showCheckView"
                      v-if="showCheckView">统一批改</mdui-button>
                    <mdui-button icon="display_settings" id="setBtn" @click="showSetView">默写设置</mdui-button>

                    <div id="checkView" style="margin-top:20px;" v-if="showCheckView">
                      <mdui-chip elevated style="font-size:30px;height:50px;" id="checkName">{{ currentWordName
                      }}</mdui-chip>
                      <mdui-button-icon variant="filled" icon="done_outline" style="background-color:#0acf97;"
                        id="checkRight" @click="markAsCorrect"></mdui-button-icon>
                      <mdui-button-icon variant="filled" icon="do_disturb_alt" style="background-color:#fa5c7c;"
                        id="checkWrong" @click="markAsWrong"></mdui-button-icon>
                    </div>
                  </div>
                </div>
                <div class="liner">
                  <!-- 进度条 -->
                  <div class="linerBar">
                    <div class="inLiner" :style="{ width: progressPercent + '%' }"></div>
                  </div>
                </div>
              </div>
            </div>

            <div class="card">
              <div class="cardItem">
                <span id="time" class="timer">{{ formatTime(elapsedSeconds) }}</span>
                <span class="cardItemP2">时间</span>
              </div>
              <div class="cardItem">
                <span id="answer" class="timer">{{ totalAnswered }}</span>
                <span class="cardItemP2">输入数</span>
              </div>
              <div class="cardItem">
                <span id="wpm" class="timer">{{ wpm }}</span>
                <span class="cardItemP2">WPM</span>
              </div>
              <div class="cardItem">
                <span id="right" class="timer">{{ correctCount }}</span>
                <span class="cardItemP2">当前正确数</span>
              </div>
              <div class="cardItem">
                <span id="allright" class="timer">{{ correctCount + baseCorrectCount }}</span>
                <span class="cardItemP2">总正确数</span>
              </div>
              <div class="cardItem">
                <span id="accuracy" class="timer">{{ accuracyPercent }}%</span>
                <span class="cardItemP2">正确率</span>
              </div>
            </div>
          </div>
        </div>
        <!-- 页脚 -->
        <footer class="mb-1 mt-4 flex w-full items-center justify-center gap-2.5 text-sm ease-in">
        </footer>
      </div>
      <div class="gameView" id="gameView">
        <iframe id="gameFrame" src="/QuickResponse/game/" width="100%" height="100%" frameborder="0"></iframe>
      </div>
    </div>

    <!-- 虚拟键盘 -->
    <div class="relative !absolute left-5 top-[50%] z-20" v-if="showKeyboard">
    </div>
    <div id="keyboardContainer" :style="{ display: showKeyboard ? 'flex' : 'none' }">
      <!-- 键盘按键将在这里动态生成 -->
      <div v-for="key in keyboardKeys" :key="key" class="key" :class="{ shifted: isShifted }"
        @click="handleKeyClick(key)">
        {{ key }}
      </div>
      <div class="key shiftKey" :class="{ shifted: isShifted }" @click="toggleShift">Shift</div>
      <div class="key shiftKey" @click="handleKeyClick(' ')">空 格</div>
      <div class="key shiftKey" @click="showWord">提 示</div>
      <div class="key shiftKey" @click="handleBackspace">删除</div>
    </div>
    <div class="key" id="closeButton" @click="toggleKeyboard">{{ keyboardButtonText }}</div>

    <!-- 设置对话框 -->
    <mdui-dialog close-on-overlay-click id="abhsSetDialog" class="example-headline-slot" v-if="showSettingsDialog">
      <span>默写设置</span>
      <div class="line-container">
        <mdui-chip elevated class="label" tabindex="-1">默写间隔</mdui-chip>
        <mdui-text-field variant="outlined" label="请设置默写间隔（单位:秒）" v-model="interval" class="input"></mdui-text-field>
      </div>
      <div class="line-container">
        <mdui-chip elevated class="label" tabindex="-1">播报次数</mdui-chip>
        <mdui-text-field variant="outlined" label="请设置播报次数" v-model="times" class="input"></mdui-text-field>
      </div>
      <div class="line-container">
        <mdui-chip elevated class="label" tabindex="-1">全部默写</mdui-chip>
        <mdui-switch v-model="writeAll"></mdui-switch>
      </div>
    </mdui-dialog>
  </div>
</template>

<script>
import TopBar from '@/components/TopBar.vue'
import abhsService from '@/services/abhsService'
import aj from '@/utils/aj.js'
import AuthService from '@/services/authService.js'

export default {
  name: 'MemorizationView',
  components: {
    TopBar
  },
  data() {
    return {
      // 用户信息
      user: {
        name: '用户名',
        id: 1,
        userType: 1,
        avatar: require('@/assets/logo.png')
      },

      // 应用列表（用于TopBar组件）
      apps: [],

      // 单词表相关
      bookType: 'abhsWords', // abhsWords 或 abhsChinese
      currentBookName: '测试单词表',
      words: [],
      currentWordIndex: 0,
      currentResults: [], // 记录每个单词的答题结果
      baseCorrectCount: 0, // 原始正确的单词数

      // 练习状态
      isRunning: false,
      isSpeaking: false,
      showCheckView: false,
      showEndView: false,
      showKeyboard: false,
      isShifted: false,
      showSettingsDialog: false,
      isGameViewExpanded: false,
      wordResult: true, // 单词是否正确

      // 计时器相关
      elapsedSeconds: 0,
      timer: null,

      // 统计数据
      correctCount: 0,
      wrongCount: 0,
      inputCount: 0,
      inputIndex: -1, // 当前输入的字母索引

      // 默写设置
      interval: 3,
      times: 2,
      writeAll: false,

      // 导航相关
      hasPreviousBook: false,
      hasNextBook: false,

      // 单词表列表
      bookList: [],
      bookIndex: 0,

      // 虚拟键盘
      keyboardKeys: [
        '1', '2', '3', '4', '5', '6', '7', '8', '9', '0',
        'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l',
        'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x',
        'y', 'z', '!', '?', '-', '+', '*', '/', '.', "'"
      ],

      // 错误单词列表
      wrongWords: [],

      // 通知消息
      noticeMessage: '',

      // 进度圆环周长
      circumference: 2 * Math.PI * 40,

      // 当前单词的字母元素列表
      spanList: [],

      // Tab键状态
      isTabPressed: false,


    }
  },
  async mounted() {
    // 组件挂载时的操作
    console.log('MemorizationView mounted')

    // 从URL参数获取bookName和bookType
    const urlParams = new URLSearchParams(window.location.search)
    const bookName = urlParams.get('bookName')
    const bookType = urlParams.get('bookType') || 'abhsWords'

    // 设置bookType
    this.bookType = bookType

    // 获取用户信息
    this.loadUserInfo()

    // 如果无法获取到用户ID，则使用默认值
    if (!this.user.id) {
      this.user.id = 1
    }

    // 获取应用列表
    await this.loadAppList()

    // 如果有bookName参数，则获取该单词表的数据
    if (bookName) {
      this.currentBookName = bookName
      await this.loadWordsData(bookName)
    }

    // 获取单词表列表用于导航
    await this.loadBookList()

    // 添加键盘事件监听器
    window.addEventListener('keydown', this.handleKeyDown)
    window.addEventListener('keyup', this.handleKeyUp)

    // 初始化防抖的readWord方法
    this.debouncedReadWord = this.debounce(function (word) {
      aj.readWord(word);
    }, 1000);
  },
  beforeUnmount() {
    // 组件卸载前的操作
    console.log('MemorizationView beforeUnmount')

    // 清理定时器
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }

    // 移除键盘事件监听器
    window.removeEventListener('keydown', this.handleKeyDown)
    window.removeEventListener('keyup', this.handleKeyUp)
  },
  computed: {
    // 当前单词信息
    currentWord() {
      return this.words[this.currentWordIndex] || {}
    },

    currentWordName() {
      return this.currentWord.name || ''
    },

    currentWordDesc() {
      return this.currentWord.desc || ''
    },

    currentWordLetters() {
      if (this.bookType !== 'abhsWords') return []

      const name = this.currentWordName
      return name.split('').map((letter, index) => ({
        value: letter,
        display: this.getLetterDisplay(index, letter),
        class: this.getLetterClass(index)
      }))
    },

    // 进度相关
    progressPercent() {
      if (this.words.length === 0) return 0
      return (this.currentResults.length / this.words.length) * 100
    },

    totalAnswered() {
      return this.correctCount + this.wrongCount
    },

    wpm() {
      if (this.elapsedSeconds === 0) return 0
      return (this.totalAnswered / (this.elapsedSeconds / 60)).toFixed(1)
    },

    accuracyPercent() {
      if (this.totalAnswered === 0) return 0
      return Math.round((this.correctCount / this.totalAnswered) * 100)
    },

    // 进度条相关
    accuracyOffset() {
      const percent = this.accuracyPercent
      const circumference = 2 * Math.PI * 40
      return circumference - (percent / 100) * circumference
    },

    // 键盘按钮文本
    keyboardButtonText() {
      if (!this.showKeyboard) return '键盘'
      if (this.keyboardButtonText === '键盘') return '简-键'
      return '隐藏'
    }
  },
  methods: {
    // 加载用户信息
    loadUserInfo() {
      const currentUser = AuthService.getCurrentUser()
      if (currentUser) {
        this.user.name = currentUser.nickname || currentUser.username || '用户名'
        this.user.id = currentUser.userid || currentUser.id || 1
        this.user.userType = currentUser.userType || 1
        if (currentUser.icon) {
          if (currentUser.icon.startsWith('/static/uploads/')) {
            this.user.avatar = currentUser.icon
          } else if (currentUser.icon.startsWith('uploads/')) {
            this.user.avatar = `/static/${currentUser.icon}`
          } else {
            this.user.avatar = `/static/uploads/${currentUser.icon}`
          }
        } else {
          this.user.avatar = require('@/assets/logo.png')
        }
      }
    },

    // 加载应用列表
    async loadAppList() {
      try {
        // 模拟应用列表数据
        // 在实际应用中，这里应该调用API获取真实的应用列表
        this.apps = [
          { id: 1, name: '待办事项', link: '/todo' },
          { id: 2, name: '词库浏览', link: '/abhs/gallery' },
          { id: 3, name: '数据可视化', link: '/datavisual' },
          { id: 4, name: '文件管理', link: '/filemanage' }
        ]
      } catch (error) {
        console.error('获取应用列表失败:', error)
      }
    },

    // 加载单词数据
    async loadWordsData(bookName) {
      try {
        const response = await abhsService.getWords(this.user.id, bookName)
        console.log('获取单词数据:', response)
        if (response.status === 200) {
          // 处理返回的数据
          this.words = response.message || []
          // 随机打乱单词顺序
          this.words = this.shuffleArray(this.words)
          // 重置练习状态
          this.resetPractice()
        } else {
          console.error('获取单词数据失败:', response.message)
        }
      } catch (error) {
        console.error('获取单词数据出错:', error)
      }
    },

    // 加载单词表列表
    async loadBookList() {
      try {
        const response = await abhsService.getWordList(this.user.id)
        console.log('获取单词表列表:', response)
        if (response.status === 200) {
          this.bookList = response.mybooks || []
          // 找到当前单词表的索引
          this.bookIndex = this.bookList.findIndex(book => book.name === this.currentBookName)
          // 更新导航状态
          this.updateNavigationStatus()
        } else {
          console.error('获取单词表列表失败:', response.message)
        }
      } catch (error) {
        console.error('获取单词表列表出错:', error)
      }
    },

    // 更新导航状态（上一节/下一节按钮）
    updateNavigationStatus() {
      this.hasPreviousBook = this.bookIndex > 0
      this.hasNextBook = this.bookIndex < this.bookList.length - 1
    },

    // 重置练习状态
    resetPractice() {
      this.currentWordIndex = 0
      this.currentResults = []
      this.baseCorrectCount = 0
      this.correctCount = 0
      this.wrongCount = 0
      this.inputCount = 0
      this.inputIndex = -1
      this.elapsedSeconds = 0
      this.stopTimer()
      this.isRunning = false
      this.showCheckView = false
      this.wordResult = true

      // 计算原始正确的单词数
      this.baseCorrectCount = this.words.filter(word => word.strength >= 4).length
    },

    // 格式化时间
    formatTime(seconds) {
      const minutes = Math.floor(seconds / 60)
      const secs = seconds % 60
      return `${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`
    },

    // 获取字母的CSS类,如果输出过不，就会自动更新状态
    getLetterClass(index) {
      // 获取字母元素，检查是否已添加right或wrong类
      let additionalClass = '';
      const letterElement = this.$refs[`letter-${index}`];

      // 如果letterElement是一个数组（多个同名ref），取第一个元素
      const element = Array.isArray(letterElement) ? letterElement[0] : letterElement;

      // 检查元素是否已添加right或wrong类
      if (element && element.classList) {
        if (element.classList.contains('right')) {
          additionalClass = 'right';
        } else if (element.classList.contains('wrong')) {
          additionalClass = 'wrong';
        }
      }

      // if (!this.isRunning || index > this.inputIndex) {
      //   return additionalClass;
      // }

      if (this.currentWordName[index] === ' ') return additionalClass;

      let baseClass = '';
      if (this.currentWordName[index] <= 'Z' && this.currentWordName[index] >= 'A') {
        baseClass = 'underline-bold';
      } else {
        baseClass = 'underline';
      }

      // 合并基础类和额外的类
      return additionalClass ? `${baseClass} ${additionalClass}` : baseClass;
    },

    // 获取字母的完整CSS类（包括基础类）
    getLetterClasses(index, dynamicClass) {
      // 始终包含基础类
      const baseClass = 'remember2111P';

      // 如果有动态类，则组合返回
      return dynamicClass ? `${baseClass} ${dynamicClass}` : baseClass;
    },

    // 获取字母的显示内容
    getLetterDisplay(index, letter) {
      // 如果正在运行且索引在已输入范围内，或Tab键被按下
      if (this.isRunning && (this.inputIndex >= index || this.isTabPressed)) {
        // 获取字母元素，检查是否已输入内容
        const letterElement = this.$refs[`letter-${index}`];

        // 如果letterElement是一个数组（多个同名ref），取第一个元素
        const element = Array.isArray(letterElement) ? letterElement[0] : letterElement;
        // console.log("1111", element)
        // 如果元素存在且有文本内容，返回实际输入的内容
        if (element && element.textContent && element.textContent != "_" && element.textContent.trim() !== '') {
          return element.textContent;
        }
        // console.log("2222", element)
        // 如果用户已经输入到这个位置，显示原字母
        if (this.inputIndex >= index) {
          return letter;
        }
        // console.log("3333", element)
        // 如果Tab键被按下，显示原字母
        if (this.isTabPressed) {
          return letter;
        }
        // console.log("4444", element)
        // 否则返回下划线
        return ' ';
      }

      // 如果是空格，返回空格
      if (letter === ' ') return ' ';

      // 否则返回下划线
      return ' ';
    },

    // 获取星星图片
    getStarImage(word, index) {
      // 这里应该根据单词的掌握程度返回不同的星星图片
      if (word.strength >= 4) {
        return this.bookType === 'abhsWords' ? require('@/assets/img/star_purple.png') : require('@/assets/img/star_green.png')
      } else if (index > this.currentResults.length - 1) {
        return require('@/assets/img/star.png')
      } else if (!this.currentResults[index]) {
        return require('@/assets/img/star.png')
      } else {
        return require('@/assets/img/star_sel.png')
      }
    },

    // 获取星星等级图片
    getStarLevelImage(level) {
      // 根据当前单词的掌握程度返回星星等级图片
      const currentWordStrength = this.currentWord.strength || 0
      if (level <= currentWordStrength) {
        return this.bookType === 'abhsWords' ? require('@/assets/img/star_purple.png') : require('@/assets/img/star_sel.png')
      } else {
        return require('@/assets/img/star.png')
      }
    },

    // 开始计时
    startTimer() {
      if (this.isRunning) return
      this.isRunning = true
      this.timer = setInterval(() => {
        this.elapsedSeconds++
      }, 1000)
    },

    // 停止计时
    stopTimer() {
      this.isRunning = false
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    },

    // 数组随机打乱
    shuffleArray(array) {
      const newArray = [...array]
      for (let i = newArray.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [newArray[i], newArray[j]] = [newArray[j], newArray[i]]
      }
      return newArray
    },

    // 清除当前单词的样式
    clearCurrentWordStyles() {
      // 遍历当前单词的所有字母
      for (let i = 0; i < this.currentWordName.length; i++) {
        // 获取字母元素，处理可能的数组情况
        let letterElement = this.$refs[`letter-${i}`];

        // 如果letterElement是一个数组（多个同名ref），取第一个元素
        if (Array.isArray(letterElement)) {
          letterElement = letterElement[0];
        }

        // 如果元素存在，清除样式
        if (letterElement && letterElement.classList) {
          letterElement.classList.remove('right', 'wrong');
          // 根据当前状态设置文本内容
          if (this.isRunning && (this.inputIndex >= i || this.isTabPressed)) {
            // 如果用户已经输入到这个位置，或Tab键被按下，显示原字母
            if (this.inputIndex >= i || this.isTabPressed) {
              letterElement.textContent = letterElement.getAttribute('data-value');
            }
          } else {
            // 否则，根据字母类型显示下划线或空格
            const letter = letterElement.getAttribute('data-value');
            //letterElement.textContent = '';
            if (letter === ' ') {
              letterElement.textContent = ' ';
            } else {
              letterElement.textContent = ' ';
            }
          }
        }
      }
    },



    // 导航方法
    goToPreviousBook() {
      if (this.bookIndex > 0) {
        this.bookIndex--
        this.currentBookName = this.bookList[this.bookIndex].name
        this.loadWordsData(this.currentBookName)
        this.updateNavigationStatus()
      }
    },

    goToNextBook() {
      if (this.bookIndex < this.bookList.length - 1) {
        this.bookIndex++
        this.currentBookName = this.bookList[this.bookIndex].name
        this.loadWordsData(this.currentBookName)
        this.updateNavigationStatus()
      }
    },

    goToRanking() {
      console.log('前往排行榜')
      // 实际应用中应该跳转到排行榜页面
    },

    goToEditBook() {
      console.log('编辑单词本')
      // 实际应用中应该跳转到编辑单词本页面
      // 传递当前单词表名称作为查询参数
      this.$router.push({
        path: '/abhs/edit',
        query: {
          bookName: this.currentBookName
        }
      })
    },

    goToGallery() {
      console.log('前往词库页面')
      // 实际应用中应该跳转到词库页面
    },

    goToMainView() {
      console.log('前往主页面')
      // 实际应用中应该跳转到主页
    },

    // 功能方法
    speakText() {
      this.isSpeaking = true
      console.log('开始播报')
    },

    stopSpeaking() {
      this.isSpeaking = false
      console.log('停止播报')
    },

    showSetView() {
      this.showSettingsDialog = true
      console.log('显示设置视图')
    },

    // 示/隐藏结束画面
    showEndViewMethod(type, step = 0) {
      console.log("showEndView")
      if (step > 0 && this.bookIndex + step < this.bookList.length) {
        this.bookIndex += step
        this.currentBookName = this.bookList[this.bookIndex].name
      }

      if (type) {
        this.updateEndView()
        this.showEndView = true
        this.stopTimer()
      } else {
        this.showEndView = false
        // 更新单词列表
        this.loadWordsData(this.currentBookName)
      }
    },

    // 更新结束画面
    updateEndView() {
      // 计算错误的单词
      this.wrongWords = []
      for (let i = 0; i < this.words.length; i++) {
        if (!this.currentResults[i]) {
          this.wrongWords.push(this.words[i])
        }
      }

      // 设置提示语
      const percent = this.accuracyPercent
      if (percent == 100) {
        this.noticeMessage = "哇！你全对！！太厉害了！"
      } else if (percent > 80) {
        this.noticeMessage = `很优秀哦！上面这 ${this.wrongCount} 个单词再看一下就行啦！`
      } else if (percent > 60) {
        this.noticeMessage = `很不错哦！上面这 ${this.wrongCount} 个单词值得再看！`
      } else if (percent > 50) {
        this.noticeMessage = `继续加油哦！超过一半你都会了！这 ${this.wrongCount} 个单词我们慢慢拿下！！`
      } else if (percent == 0) {
        this.noticeMessage = `本节就剩上面${this.wrongCount}个单词了，你肯定能拿下！`
      } else {
        this.noticeMessage = `再接再厉！！这次你又对了 ${this.correctCount} 个单词呢！上面${this.wrongCount}个肯定也能拿下！`
      }
    },

    // 切换游戏视图
    toggleGameView() {
      this.isGameViewExpanded = !this.isGameViewExpanded
    },

    // 切换键盘显示
    toggleKeyboard() {
      this.showKeyboard = !this.showKeyboard
    },

    // 切换Shift状态
    toggleShift() {
      this.isShifted = !this.isShifted
    },

    // 处理按键点击
    handleKeyClick(key) {
      if (key === "Tab") {
        this.showWord()
        return
      }

      if (this.isShifted && key.length === 1) {
        key = key.toUpperCase()
      }

      console.log(key)
      if (!this.isRunning) {
        this.startTimer()
      }

      // 处理输入键
      this.inputKey(key)
    },

    // 处理退格键
    handleBackspace() {
      console.log("处理退格键")
      if (this.inputIndex >= 0) {
        this.inputIndex--
      }
    },

    // 显示单词
    async showWord() {
      console.log("显示单词")
      // // 将当前单词的所有字母显示出来
      // this.inputIndex = this.currentWordName.length - 1
      // this.wordResult = false // 标记为错误
      if (this.wordResult) {
        this.wordResult = false;
        //阻止tab切换出页面
        await this.changeGraph();
      }
      // 设置isTabPressed为true，让getLetterDisplay方法显示所有字母
      this.isTabPressed = true;
      //播放声音
      this.debouncedReadWord(this.currentWordName);
      //设置1秒内只执行一次播放声音

      console.log("Tab 键被按下");

    },
    debounce(func, delay) {
      let timeoutId;

      return function () {
        const context = this;
        const args = arguments;

        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
          func.apply(context, args);
        }, delay);
      };
    },
    // 防抖的readWord方法
    debouncedReadWord: null,
    async changeGraph() {
      console.log("changeGraph wordResult:", this.wordResult)
      try {
        // 调用API更新单词掌握程度
        const response = await abhsService.changeStrength(
          this.user.id,
          this.currentWord.fromNode_id,
          this.currentWord.toNode_id,
          this.wordResult
        );

        console.log("success:", response);

        // 显示提示信息
        if (response && response.message) {
          // 使用aj工具类显示提示信息
          if (typeof aj !== 'undefined' && typeof aj.showTip === 'function') {
            aj.showTip(response.message);
          } else {
            // console.log("no aj.showTip");
            // 如果aj.showTip不可用，使用console.log显示
            console.log(response.message);
          }
        }

        // 检查响应状态
        if (response.status === 200) {
          // 成功处理
          console.log("单词掌握程度更新成功");
        } else if (response.status === 400) {
          // 错误处理
          console.log("单词掌握程度更新失败:", response.message);
        }
      } catch (error) {
        console.error("更新单词掌握程度时发生错误:", error);
        // 如果有aj工具类，显示错误提示
        if (typeof aj !== 'undefined' && typeof aj.showTip === 'function') {
          aj.showTip("更新失败: " + error.message);
        }
      }
    },
    // 隐藏单词
    hideWord() {
      console.log("隐藏单词")
      // 隐藏当前单词中未输入的字母
      // 这个功能在computed属性中通过currentWordLetters自动实现
      // 当isTabPressed变为false时，computed属性会自动更新视图
    },

    // 处理键盘按下事件
    handleKeyDown(event) {
      console.log("keydown", event.key)


      // 阻止Tab键的默认行为
      if (event.key === 'Tab') {
        event.preventDefault()
      }

      if (this.bookType === "abhsWords") {
        // 获取输入的按键
        const key = event.key

        // 判断是否是字母、空格、数字或基本符号
        const isAllowedInput = /^[a-zA-Z0-9\s`~!@#$%^&*()\-_=+[{\]}\\|;:'",<.>/?]+$/.test(key) &&
          (!event.shiftKey || key === "?" || key === "!") &&
          !event.ctrlKey &&
          !event.altKey &&
          event.code !== "CapsLock" &&
          event.code !== "Enter" &&
          event.code !== "Escape" &&
          event.key !== 'Tab' &&
          event.key !== "Backspace" &&
          !(event.key.startsWith("F") && key !== 'F')

        if (isAllowedInput && this.isRunning) {
          this.inputKey(key)
        } else if (event.key === "Backspace") {
          console.log("Backspace 键被按下")
          if (this.inputIndex >= 0) {
            // 更新当前字母的显示状态
            this.inputIndex--
          }
        } else if (event.key === "Tab") {
          event.preventDefault()
          this.isTabPressed = true
          this.showWord()
        }
      } else {
        console.log("非单词默写模式")
      }


      // // 阻止Tab键的默认行为
      // if (event.key === 'Tab') {
      //   event.preventDefault()
      // }
    },

    // 处理键盘释放事件
    handleKeyUp(event) {
      console.log("keyup", event.key)

      // 处理Tab键
      if (event.key === 'Tab' && this.bookType === "abhsWords") {
        console.log("Tab键被释放")
        this.isTabPressed = false
        this.hideWord()
      } else if (this.showEndView) {
        // 如果结束视图显示，按Enter键进入下一章节
        console.log("本节已结束")
        if (event.key === 'Enter') {
          const nextBookBtn = document.getElementById("nextBook")
          if (nextBookBtn) {
            nextBookBtn.click() // 模拟点击提交按钮
          }
        }
      } else if (!this.isRunning && this.bookType === "abhsWords") {
        // 如果还没有开始，按任意键开始
        this.startTimer()
      } else if (event.key === 'Escape' && this.bookType === "abhsWords") {
        // 按ESC键停止计时
        this.stopTimer()
      }
    },

    // 处理输入键
    async inputKey(key) {
      console.log("input key is:", key)
      if (this.bookType !== "abhsWords") return

      this.inputIndex++
      this.inputCount++
      console.log("inputIndex:", this.inputIndex)

      // 检查输入是否正确
      if (this.inputIndex <= this.currentWordName.length - 1) {
        // 获取字母元素，处理可能的数组情况
        let letterElement = this.$refs[`letter-${this.inputIndex}`];

        // 如果letterElement是一个数组（多个同名ref），取第一个元素
        if (Array.isArray(letterElement)) {
          letterElement = letterElement[0];
        }
        console.log("letterElement:", letterElement)
        if (this.currentWordName[this.inputIndex] === key ||
          (this.currentWordName[this.inputIndex] === " " && key === " ")) {
          // 输入正确
          console.log("输入正确")
          // 播放正确的声音
          const audio = new Audio(require('@/assets/sounds/click.wav'));
          audio.play();

          // 更新字母显示和样式
          if (letterElement && letterElement.classList) {
            letterElement.textContent = key;
            letterElement.classList.add('right');
            // console.log("letterElement is not null")
            // console.log("letterElement.classList:", letterElement.classList)
          }

          // 如果输入完所有字母
          if (this.inputIndex === this.currentWordName.length - 1) {
            // 记录结果
            this.currentResults.push(this.wordResult)
            // 如果正确，则计数+1
            if (this.wordResult) {
              this.correctCount++
              // 调用API更新单词掌握程度
              await this.changeGraph();
            } else {
              this.wrongCount++
            }

            // 移动到下一个单词
            if (this.currentWordIndex < this.words.length - 1) {
              this.currentWordIndex++
              this.inputIndex = -1
              this.wordResult = true
              // 使用nextTick确保DOM更新后再清除样式
              this.$nextTick(() => {
                this.clearCurrentWordStyles();
              });
            } else {
              // 完成所有单词
              this.stopTimer()
              this.showEndViewMethod(true)
            }
          }
        } else {
          // 输入错误
          console.log("输入错误")
          // 播放错误的声音
          const audio = new Audio(require('@/assets/sounds/correct.wav'));
          audio.play();

          // 更新字母显示和样式
          if (letterElement && letterElement.classList) {
            letterElement.textContent = key;
            letterElement.classList.add('wrong');
          }

          // 标记为错误
          if (this.wordResult) {
            this.wordResult = false
            // 调用API更新单词掌握程度
            await this.changeGraph();
          }

          // 如果输入完所有字母
          if (this.inputIndex === this.currentWordName.length - 1) {
            // 记录结果
            this.currentResults.push(this.wordResult)
            // 如果正确，则计数+1
            if (this.wordResult) {
              this.correctCount++
              // 调用API更新单词掌握程度
              await this.changeGraph();
            } else {
              this.wrongCount++
            }

            // 移动到下一个单词
            if (this.currentWordIndex < this.words.length - 1) {
              this.currentWordIndex++
              this.inputIndex = -1
              this.wordResult = true
              // 重置Tab键状态
              this.isTabPressed = false
              // 使用nextTick确保DOM更新后再清除样式
              this.$nextTick(() => {
                this.clearCurrentWordStyles();
              });
            } else {
              // 完成所有单词
              this.stopTimer()
              this.showEndViewMethod(true)
            }
          }
        }
      }
    },

    // 标记为正确
    markAsCorrect() {
      if (this.currentResults.length <= this.currentWordIndex) {
        this.currentResults.push(true)
        this.correctCount++
      } else if (!this.currentResults[this.currentWordIndex]) {
        this.currentResults[this.currentWordIndex] = true
        this.correctCount++
        this.wrongCount--
      }

      // 移动到下一个单词
      if (this.currentWordIndex < this.words.length - 1) {
        this.currentWordIndex++
        this.inputIndex = -1
        this.wordResult = true
        // 重置Tab键状态
        this.isTabPressed = false
        // 使用nextTick确保DOM更新后再清除样式
        this.$nextTick(() => {
          this.clearCurrentWordStyles();
        });
      } else {
        // 完成所有单词
        this.stopTimer()
      }
    },

    // 标记为错误
    markAsWrong() {
      if (this.currentResults.length <= this.currentWordIndex) {
        this.currentResults.push(false)
        this.wrongCount++
      } else if (this.currentResults[this.currentWordIndex]) {
        this.currentResults[this.currentWordIndex] = false
        this.correctCount--
        this.wrongCount++
      }

      // 移动到下一个单词
      if (this.currentWordIndex < this.words.length - 1) {
        this.currentWordIndex++
        this.inputIndex = -1
        this.wordResult = true
        // 重置Tab键状态
        this.isTabPressed = false
        // 使用nextTick确保DOM更新后再清除样式
        this.$nextTick(() => {
          this.clearCurrentWordStyles();
        });
      } else {
        // 完成所有单词
        this.stopTimer()
        this.showEndViewMethod(true)
      }
    }
  }
}
</script>

<style scoped>
/* .root {
  min-height: 100vh;
  background-color: #f5f5f5;
}

.bodyView {
  display: flex;
  height: 100vh;
}



.mainView {
  flex: 1;
  overflow-y: auto;
}

.container {
  background-color: #fff;
  padding: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.containerDiv {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.containerTitle {
  margin: 0;
  font-size: 24px;
  color: rgb(99 102 241);
  text-decoration-line: none;
  font-weight: 700;
  font-size: 1.5rem;
  line-height: 2rem;
  align-items: center;
  display: flex;
}

.body {
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
}

.centerItem {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.center {
  background-color: #fff;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.center2 {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.reminder {
  display: flex;
  gap: 5px;
  margin-bottom: 20px;
}

.remember {
  width: 100%;
  text-align: center;
}

.starView {
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-bottom: 20px;
}

.remember1 {
  margin-bottom: 30px;
}

.runStatus {
  margin-bottom: 20px;
}

.remmberP {
  font-size: 18px;
  color: #666;
}

.word {
  font-size: 36px;
  font-weight: bold;
  color: #333;
  margin-bottom: 10px;
}


.desc {
  font-size: 18px;
  color: #666;
}

.liner {
  width: 100%;
  margin-top: 20px;
}

.linerBar {
  width: 100%;
  height: 10px;
  background-color: #e0e0e0;
  border-radius: 5px;
  overflow: hidden;
}

.inLiner {
  height: 100%;
  background-color: #007bff;
  transition: width 0.3s ease;
}

.card {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 20px;
  background-color: #fff;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.cardItem {
  text-align: center;
}

.timer {
  display: block;
  font-size: 24px;
  font-weight: bold;
  color: #333;
}

.cardItemP2 {
  font-size: 14px;
  color: #666;
}

.menu {
  display: flex;
  align-items: center;
  gap: 30px;
}

.menuBtn {
  cursor: pointer;
  text-decoration: none;
  color: #333;
}

.menuBtn:hover {
  text-decoration: underline;
}

.nav-arrow {
  cursor: pointer;
}

.gameView {
  width: 0;
  transition: width 0.3s ease;
}

.gameView.expanded {
  width: 70vw;
}

.popView {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
}

.grayView {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}

.popContent {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: white;
  border-radius: 8px;
  padding: 20px;
  min-width: 500px;
}

.popContentView {
  display: flex;
  flex-direction: column;
}

.title {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 20px;
}

.closeBtn {
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  cursor: pointer;
}

.midContent {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
}

.leftItem {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.progress-container {
  text-align: center;
}

.progress-circle {
  transform: rotate(-90deg);
}

.progress-bar {
  fill: none;
  stroke: #007bff;
  stroke-width: 8;
  transition: stroke-dashoffset 0.3s ease;
}

.percentValue {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 20px;
  font-weight: bold;
}

.percentName {
  display: block;
  margin-top: 40px;
  font-size: 14px;
}

.midItem {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.wrongList {
  flex: 1;
  overflow-y: auto;
  max-height: 200px;
}

.wrongWord {
  display: block;
  margin: 5px 0;
  padding: 5px 10px;
  background-color: #f5f5f5;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.wrongWord:hover {
  background-color: #e0e0e0;
}

.noticeFooter {
  margin-top: auto;
}

.noticeItem {
  display: flex;
  align-items: center;
  gap: 10px;
}

.noticeSvg {
  flex-shrink: 0;
}

.noticeValue {
  flex: 1;
}

.rightItem {
  display: flex;
  align-items: flex-start;
}

.btnSvg {
  background: none;
  border: none;
  cursor: pointer;
}

.bottomContent {
  display: flex;
  justify-content: center;
  gap: 10px;
}

.bottomBtn1,
.bottomBtn2 {
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.bottomBtn1 {
  background-color: #007bff;
  color: white;
}

.bottomBtn2 {
  background-color: #28a745;
  color: white;
}

#keyboardContainer {
  position: fixed;
  bottom: 50px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  background-color: #f5f5f5;
  padding: 10px;
  border-radius: 8px;
  max-width: 90%;
}

.key {
  padding: 10px 15px;
  background-color: #ddd;
  border: 1px solid #bbb;
  border-radius: 4px;
  cursor: pointer;
  user-select: none;
}

.key:hover {
  background-color: #ccc;
}

.key.active {
  background-color: #aaa;
}

.key.shifted {
  background-color: #999;
}

.shiftKey {
  background-color: #999;
}

.shiftKey.shifted {
  background-color: #666;
}
 */


.remember2111P {
  display: inline-block;
  min-width: 2rem;
  text-align: center;
  min-height: 72px;
  line-height: 72px;
  height: 72px;
  vertical-align: top;
  margin-right: 0.2rem;
}

.remember2111P.right {
  color: green;
  background-color: rgba(0, 128, 0, 0.1);
}

.remember2111P.wrong {
  color: red;
  background-color: rgba(255, 0, 0, 0.1);
}

.remember2111P.underline {
  border-bottom: 2px solid black;
}

.remember2111P.underline-bold {
  border-bottom: 5px solid black;
}

.side_btn {
  height: 30px;
  border-radius: 10%;
  background: #42b983;
  color: white;
  border: none;
  font-size: 20px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.side_btn:hover {
  background: #359c6d;
}

*,
::before,
::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x: ;
  --tw-pan-y: ;
  --tw-pinch-zoom: ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position: ;
  --tw-gradient-via-position: ;
  --tw-gradient-to-position: ;
  --tw-ordinal: ;
  --tw-slashed-zero: ;
  --tw-numeric-figure: ;
  --tw-numeric-spacing: ;
  --tw-numeric-fraction: ;
  --tw-ring-inset: ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur: ;
  --tw-brightness: ;
  --tw-contrast: ;
  --tw-grayscale: ;
  --tw-hue-rotate: ;
  --tw-invert: ;
  --tw-saturate: ;
  --tw-sepia: ;
  --tw-drop-shadow: ;
  --tw-backdrop-blur: ;
  --tw-backdrop-brightness: ;
  --tw-backdrop-contrast: ;
  --tw-backdrop-grayscale: ;
  --tw-backdrop-hue-rotate: ;
  --tw-backdrop-invert: ;
  --tw-backdrop-opacity: ;
  --tw-backdrop-saturate: ;
  --tw-backdrop-sepia: ;
}

*,
::before,
::after {
  box-sizing: border-box;
  border-width: 0;
  border-style: solid;
  border-color: #e5e7eb;
}

.bodyView {
  display: flex;
  width: 100%;
  height: 100vh;
  /* 使用视口高度 */
  transition: all 0.3s ease;
}

.mainView {
  padding-bottom: 1rem;
  flex: 1;
  /* 占用剩余空间 */
  transition: width 0.3s ease;
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: 80vh;
  display: flex;
  /* background-color: aquamarine; */
}

.gameView {
  background-color: lightgreen;
  flex: 0;
  /* 默认隐藏 */
  width: 0;
  overflow: hidden;
  /* 隐藏超出部分 */
  transition: width 0.3s ease;
}

/* 点击按钮后应用的样式 */
.bodyView.expanded .mainView {
  width: 30vw;
  /* 30% 宽度 */
}

.bodyView.expanded .gameView {
  flex: 0 0 70vw;
  /* 70% 宽度 */
  width: 70vw;
  /* 70% 宽度 */
}

.container {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
  padding-left: 2.5rem;
  padding-right: 2.5rem;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  z-index: 20;
  max-width: 768px;
  /* background-color: burlywood; */
}

.containerDiv {
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  width: 100%;
  display: flex;
}

.containerTitle {
  text-decoration-line: none;
  --tw-text-opacity: 1;
  color: rgb(99 102 241 / var(--tw-text-opacity));
  font-weight: 700;
  font-size: 1.5rem;
  line-height: 2rem;
  align-items: center;
  display: flex;
  text-decoration: inherit;
}

.menu {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
  box-shadow: 0px 100px 80px rgb(50 46 129 / 7%), 0px 41.7776px 33.4221px rgb(50 46 129 / 5%), 0px 22.3363px 17.869px rgb(50 46 129 / 4%), 0px 12.5216px 10.0172px rgb(50 46 129 / 4%), 0px 6.6501px 5.32008px rgb(50 46 129 / 3%), 0px 2.76726px 2.21381px rgb(50 46 129 / 2%);
  animation-duration: 300ms;
  transition-duration: 300ms;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  padding: 1rem;
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
  border-radius: 0.75rem;
  justify-content: flex-end;
  align-items: center;
  width: auto;
  display: flex;
}

.relative {
  position: relative;
  /* margin-right: 0.5em; */
}

.menuBtn {
  animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  animation-duration: 300ms;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 300ms;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  font-size: 1.125rem;
  line-height: 1.75rem;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  border-radius: 0.5rem;
  display: block;
  color: inherit;
  text-decoration: inherit;
}

.menuBtnBottom {
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
  opacity: 0;
  padding-bottom: 0.5rem;
  justify-content: center;
  align-items: center;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  --tw-translate-x: -50%;
  display: flex;
  left: 50%;
  bottom: 100%;
  position: absolute;
  pointer-events: none;
}

.body {
  padding-bottom: 1rem;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  flex: 0 0 0%;
  height: 80%;
  display: flex;
  margin-left: auto;
  margin-right: auto;
  max-width: 768px;
  width: 100%;
}

/* 默写区 */
.centerItem {
  align-items: center;
  flex-direction: column;
  height: 70%;
  display: flex;
  margin-left: auto;
  margin-right: auto;
  position: relative;
  max-width: 768px;
  width: 100%;
}

.center {
  justify-content: center;
  align-items: center;
  flex-grow: 1;
  display: flex;
  max-width: 768px;
  width: 100%;
}

.center2 {
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: 100%;
  display: flex;
  max-width: 768px;
}

.reminder {
  padding-top: 0.5rem;
  padding-left: 3rem;
  padding-right: 3rem;
  justify-content: space-between;
  flex-grow: 0;
  flex-shrink: 0;
  width: 100%;
  height: 3rem;
  display: flex;
  max-width: 768px;
  flex-wrap: wrap;
}

.remember {
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  flex-grow: 1;
  display: flex;
  max-width: 768px;
  width: 100%;
  margin-bottom: 1rem;
}

.remember1 {
  justify-content: center;
  width: 100%;
  display: flex;
  position: relative;
}

.runStatus {
  justify-content: center;
  width: 100%;
  height: 100%;
  display: flex;
  position: absolute;
  /* display: block; */
}

.remember111 {
  /* backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia); */
  backdrop-filter: brightness(200%) contrast(50%) opacity(0.5);
  background-color: rgba(255, 255, 255, 0.9);
  align-items: center;
  width: 100%;
  display: flex;
  z-index: 10;
}

.remmberP {
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity));
  font-size: 1.25rem;
  line-height: 1.75rem;
  text-align: center;
  user-select: none;
  width: 100%;
  margin: 0;

}

.remember21 {
  padding-top: 1rem;
  padding-bottom: 0.25rem;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  display: flex;
}

.remember211 {
  --tooltip-color: hsl(var(--in));
  --tooltip-text-color: hsl(var(--inc));
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  line-height: 1.5;
  padding: 0px;
  background-color: transparent;
  width: fit-content;
  position: relative;
  white-space: nowrap;
  border-radius: 0.5rem;
  --tw-bg-opacity: 1;
  font-size: 0.75rem;
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity));
  display: inline-block;
  text-align: center;
  --tooltip-tail: 0.1875rem;
  --tooltip-tail-offset: calc(100% + 0.0625rem - var(--tooltip-tail));
  --tooltip-offset: calc(100% + 1px + var(--tooltip-tail, 0px));
}

.word {
  font-size: 3rem;
  justify-content: center;
  align-items: center;
  display: flex;
  flex-wrap: wrap;
}

.desc {
  justify-content: center;
  align-items: center;
  display: flex;
}

.lettle {
  height: 72px;
  min-height: 72px;
  line-height: 72px;
  font-size: 3rem;
  animation-duration: 0ms;
  transition-duration: 0ms;
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity));
  font-weight: 400;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  padding-right: 0.2rem;
  padding: 0px;
  margin: 0px;
  margin-right: 5px;
  min-width: 1rem;
  vertical-align: top;
}

.lettle.right {
  color: lightgreen;
  background-color: rgba(144, 238, 144, 0.1);
  height: 72px;
}

.lettle.wrong {
  color: lightcoral;
  background-color: rgba(240, 128, 128, 0.1);
  height: 72px;
}

.remember2112 {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  --tw-translate-y: -50%;
  width: 2.25rem;
  height: 2.25rem;
  top: 50%;
  right: -3rem;
  position: absolute;
}

.remember21121 {
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity));
  cursor: pointer;
  width: 100%;
  height: 100%;
  --webkit-appearance: button;
  background-color: transparent;
  background-image: none;
  text-transform: none;
  font-family: inherit;
  font-size: 100%;
  font-weight: inherit;
  line-height: inherit;
  color: inherit;
  margin: 0;
  padding: 0;

}

.remember21122 {
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
  opacity: 0;
  padding-bottom: 0.5rem;
  justify-content: center;
  align-items: center;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  --tw-translate-x: -50%;
  display: flex;
  left: 50%;
  bottom: 100%;
  position: absolute;
  pointer-events: none;
}

.remember22 {
  animation-duration: 300ms;
  transition-duration: 300ms;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity));
  font-weight: 400;
  font-size: 0.875rem;
  line-height: 1.25rem;
  text-align: center;
}

.remember23 {
  padding-top: 1.25rem;
  padding-bottom: 1rem;
  justify-content: center;
  align-items: center;
  display: flex;
}

.remember23P {
  /* color: greenyellow; */
  font-size: 2rem;
  animation-duration: 300ms;
  transition-duration: 300ms;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  text-align: center;
  max-width: 56rem;

}

.liner {
  /* background-color: #007bff; */
  opacity: 1;
  padding-top: 0.25rem;
  width: 25%;
  margin-top: auto;
  margin-bottom: 2.5rem;
  position: relative;
  display: flex;
  flex-direction: column;
}

.linerBar {
  width: 100%;
  animation-duration: 300ms;
  transition-duration: 300ms;
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  font-size: 0.75rem;
  line-height: 1rem;
  --tw-bg-opacity: 1;
  background-color: rgb(224 231 255 / var(--tw-bg-opacity));
  border-radius: 0.75rem;
  overflow: hidden;
  height: 0.5rem;
  display: flex;
  margin-bottom: 1rem;
}

.inLiner {
  width: 5%;
  animation-duration: .3s;
  transition-duration: .3s;
  transition-property: all;
  transition-timing-function: cubic-bezier(.4, 0, .2, 1);
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
  text-align: center;
  --tw-bg-opacity: 1;
  background-color: rgb(199 210 254 / var(--tw-bg-opacity));
  border-radius: .75rem;
  white-space: nowrap;
  justify-content: center;
  flex-direction: column;
  display: flex;

}

.card {
  box-shadow: 0px 100px 80px rgb(50 46 129 / 7%), 0px 41.7776px 33.4221px rgb(50 46 129 / 5%), 0px 22.3363px 17.869px rgb(50 46 129 / 4%), 0px 12.5216px 10.0172px rgb(50 46 129 / 4%), 0px 6.6501px 5.32008px rgb(50 46 129 / 3%), 0px 2.76726px 2.21381px rgb(50 46 129 / 2%);
  animation-duration: 300ms;
  transition-duration: 300ms;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  opacity: 0.5;
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
  padding: 1rem;
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
  border-radius: 0.75rem;
  width: 80%;
  display: flex;
}

.cardItem {
  justify-content: center;
  align-items: center;
  flex-direction: column;
  flex: 1 1 0%;
  display: flex;
}

.timer {
  animation-duration: 300ms;
  transition-duration: 300ms;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity));
  font-weight: 700;
  font-size: 1.25rem;
  line-height: 1.75rem;
  text-align: center;
  padding-bottom: 0.5rem;
  border-bottom-width: 1px;
  width: 80%;
}

.cardItemP2 {
  animation-duration: 300ms;
  transition-duration: 300ms;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  font-size: 0.75rem;
  line-height: 1rem;
  padding-top: 0.5rem;

}

.starView {
  display: flex;
  justify-content: center;
  align-items: center;
}

.dropdownMenu {
  position: absolute;
  top: 100%;
  /* 从 menuBtn 底部开始 */
  left: 0;
  /* 在 menuBtn 左侧对齐 */
  display: none;
  margin: 0 auto;
}

ul {
  list-style: none;
  /* 去除默认的列表样式 */
  padding: 0;
  /* 去除默认的内边距 */
}

li {
  background-color: lightblue;
  border-radius: 5px;
  color: green;
  text-align: center;
  padding: 10px;
}

/* 用于自动调出键盘的input */
#hiddenInput {
  position: absolute;
  left: -9999px;
}

/* 以下是键盘的效果 */
#keyboardContainer {
  width: 100%;
  background-color: #f2f2f2;
  padding: 10px;
  box-sizing: border-box;
  position: fixed;
  bottom: 0;
  left: 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}

.key {
  display: inline-block;
  min-width: 40px;
  height: 40px;
  text-align: center;
  background-color: #fff;
  margin-right: 5px;
  margin-bottom: 5px;
  line-height: 40px;
  font-size: 16px;
  border-radius: 5px;
  cursor: pointer;
  position: relative;
  /* 添加相对定位 */
  /* transition: background-color 0.3s; */
}

.shiftKey {
  min-width: 80px;
}

.shifted {
  text-transform: uppercase;
  background-color: aquamarine;
}

.active {
  background-color: #f0f0f0;
}

#closeButton {
  position: fixed;
  bottom: 10px;
  right: 10px;
  width: 40px;
  height: 40px;
  background-color: #f2f2f2;
  border-radius: 50%;
  text-align: center;
  line-height: 40px;
  cursor: pointer;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

/* 按键边框样式 */
.key::after {
  content: '';
  position: absolute;
  top: -2px;
  left: -2px;
  right: -2px;
  bottom: -2px;
  border: 2px solid transparent;
  border-radius: 10px;
  animation: shining 2s infinite;
  transition: border-color 1s, box-shadow 1s;
}

/* 按键边框动画 */

@keyframes shining {
  0% {
    border-color: transparent;
    box-shadow: none;
  }

  50% {
    border-color: var(--random-color);
    box-shadow: 0 0 10px 5px var(--random-color);
  }

  100% {
    border-color: transparent;
    box-shadow: none;
  }
}

/* 以下是弹窗的功能 */
.popView {
  overflow-y: auto;
  z-index: 30;
  inset: 0px;
  position: fixed;
  /* display: none; */
  /* display: block; */
}

.grayView {
  opacity: .8;
  --tw-bg-opacity: 1;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity));
  inset: 0px;
  position: absolute;
}

.popContent {
  justify-content: center;
  align-items: center;
  height: 100vh;
  display: flex;

}

.popContentView {
  width: 90%;
  /* 设置阴影效果 */
  box-shadow: 0 100px 80px #322e8112, 0 41.7776px 33.4221px #322e810d, 0 22.3363px 17.869px #322e810b, 0 12.5216px 10.0172px #322e8109, 0 6.6501px 5.32008px #322e8107, 0 2.76726px 2.21381px #322e8105;
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / .1), 0 4px 6px -4px rgb(0 0 0 / .1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  padding-top: 2.5rem;
  padding-right: 1.25rem;
  padding-left: 1rem;
  padding-bottom: 3.5rem;
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
  border-radius: 1.5rem;
  overflow: hidden;
  flex-direction: column;
  max-width: 72rem;
  display: flex;
  position: fixed;


}

.title {
  font-size: 1.5rem;
  line-height: 2rem;
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity));
  font-weight: 400;
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, Noto Sans, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", Segoe UI Symbol, "Noto Color Emoji";
  text-align: center;
}

.closeBtn {
  top: 1.25rem;
  right: 1.75rem;
  position: absolute;
  cursor: pointer;
  /* -webkit-appearance: button; */
  background-color: transparent;
  background-image: none;
  text-transform: none;
  font-family: inherit;
  font-size: 0.625rem;
  font-weight: inherit;
  line-height: inherit;
  color: inherit;
  margin: 0;
  padding: 0;
}

.svgBox {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity));
  display: block;
  vertical-align: middle;
}

.midContent {
  overflow: hidden;
  gap: 0.5rem;
  flex-direction: row;
  display: flex;
  margin-top: 2.5rem;

}

.leftItem {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
  gap: 0.5rem;
  flex-direction: column;
  flex-grow: 0;
  flex-shrink: 0;
  display: flex;
}

.midItem {
  --tw-bg-opacity: 1;
  background-color: rgb(238 242 255 / var(--tw-bg-opacity));
  border-radius: 0.75rem;
  overflow: visible;
  flex: 1 1 0%;
  margin-left: 1.5rem;
  z-index: 10;
}

.rightItem {
  font-size: 1.25rem;
  line-height: 1.75rem;
  gap: 0.875rem;
  justify-content: flex-end;
  align-items: center;
  flex-direction: column;
  display: flex;
  margin-left: 0.5rem;
}


.progress-container {
  width: 6.25rem;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.progress-circle {
  fill: none;
  stroke: #e5e5e5;
  stroke-width: 10;
}

.progress-bar {
  fill: none;
  stroke: #007bff;
  stroke-width: 10;
  stroke-linecap: round;
  stroke-dasharray: 0;
  transition: stroke-dasharray 0.5s;
}

.percentValue {
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / var(--tw-text-opacity));
  --tw-numeric-spacing: tabular-nums;
  font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
  font-size: 1.25rem;
  line-height: 1.75rem;
  position: absolute;
  top: 25%;
}

.percentName {
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity));
  font-weight: 500;
  font-size: 0.875rem;
  line-height: 1.25rem;
  position: absolute;
  top: 55%;
}

.wrongList {
  padding-top: 2.25rem;
  padding-right: 1.75rem;
  overflow-x: hidden;
  overflow-y: auto;
  gap: 1rem;
  align-content: flex-start;
  flex-wrap: wrap;
  flex-direction: row;
  height: 20rem;
  display: flex;
  margin-right: 0.25rem;
  margin-left: 2rem;
}

.noticeFooter {
  padding-left: 1rem;
  padding-right: 1rem;
  --tw-bg-opacity: 1;
  background-color: rgb(199 210 254 / var(--tw-bg-opacity));
  border-bottom-right-radius: 0.75rem;
  border-bottom-left-radius: 0.75rem;
  justify-content: flex-start;
  flex-direction: row;
  width: 100%;
  display: flex;

}

.wrongWord {
  user-select: all;
  height: 1.5rem;
  padding: 0.25rem 0.5rem;
  display: flex;
  width: auto;
  cursor: pointer;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border-radius: 0.375rem;
  border-width: 2px;
  border-style: solid;
  --tw-border-opacity: 1;
  border-color: rgb(129 140 248 / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
  padding: 0.125rem 0.125rem;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(.4, 0, .2, 1);
  transition-duration: .1s;
  -webkit-animation-duration: .1s;
  animation-duration: .1s;
  background-color: transparent;
  background-image: none;
  text-transform: none;
  font-family: inherit;
  font-size: 0.625rem;
  font-weight: inherit;
  line-height: inherit;
  color: inherit;
  margin: 0;
}

.noticeItem {
  align-items: center;
  flex-direction: row;
  height: 2.5rem;
  display: flex;
}

.noticeSvg {
  --tw-text-opacity: 1;
  color: rgb(79 70 229 / var(--tw-text-opacity));
  width: 1.25rem;
  height: 1.25rem;
  display: block;
  vertical-align: middle;
}

.noticeValue {
  font-size: 1rem;
  line-height: 1.5rem;
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity));
  font-weight: 500;
  vertical-align: middle;
  display: inline-block;
  margin-left: 0.5rem;
}

.btnSvg {
  --tw-text-opacity: 1;
  color: rgb(129 140 248 / var(--tw-text-opacity));
  font-size: 1.25rem;
  line-height: 1.75rem;
  cursor: pointer;
  background-color: transparent;
  background-image: none;
  text-transform: none;
  font-family: inherit;
  font-weight: inherit;
  margin: 0;
  padding: 0;

}

.bottomContent {
  font-size: 1.25rem;
  line-height: 1.75rem;
  padding-left: 1.25rem;
  padding-right: 1.25rem;
  gap: 1.25rem;
  justify-content: center;
  width: 100%;
  display: flex;
  margin-top: 2.5rem;
  flex-wrap: wrap;
}

a {
  /* 去除a标签的划线和颜色默认效果 */
  text-decoration: none;
  /* 去除链接的下划线 */
  cursor: pointer;
  /* 将光标样式更改为指针，以表示可点击 */
}

.bottomBtn1 {
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity));
  font-size: 1rem;
  line-height: 1.5rem;
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity));
  border-style: solid;
  border-width: 2px;
  height: 3rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.5rem;
  padding: 0.25rem 0.25rem;
  background-image: none;
  cursor: pointer;
  text-transform: none;
  font-family: inherit;
  font-size: 100%;
  font-weight: inherit;
  line-height: inherit;
  color: inherit;
  margin: 0;
  min-width: 10rem;
}

.bottomBtn2 {
  font-weight: 700;
  font-size: 1rem;
  line-height: 1.5rem;
  height: 3rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.5rem;
  --tw-bg-opacity: 1;
  background-color: rgb(129 140 248 / var(--tw-bg-opacity));
  padding: 0.25rem 1.5rem;
  font-size: 1.125rem;
  line-height: 1.75rem;
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
  background-image: none;
  cursor: pointer;
  text-transform: none;
  font-family: inherit;
  margin: 0;
  min-width: 10rem;
}

@media (max-width: 768px) {
  .containerDiv {
    flex-direction: column;
    gap: 15px;
  }

  .menu {
    flex-wrap: wrap;
    justify-content: center;
  }

  .card {
    grid-template-columns: repeat(2, 1fr);
  }

  .midContent {
    flex-direction: column;
  }

  .popContent {
    min-width: 90%;
  }
}
</style>